export const COMPARE_DETAIL_PREFIX = 'Codi-vs-';
